import { computed } from '@vue/composition-api'

export default function useSecaoClienteAlteracoes(historico) {
  const secaoClienteFoiAlterada = computed(
    () =>
      (historico.value.clienteNome && historico.value.clienteNomeAnterior) ||
      (historico.value.clienteEmail && historico.value.clienteEmailAnterior) ||
      (historico.value.clienteCpf && historico.value.clienteCpfAnterior) ||
      (historico.value.clienteRg && historico.value.clienteRgAnterior) ||
      (historico.value.clienteOrgaoEmissor && historico.value.clienteOrgaoEmissorAnterior) ||
      (historico.value.clienteDataNascimento && historico.value.clienteDataNascimentoAnterior) ||
      (historico.value.cep && historico.value.clienteCepAnterior) ||
      (historico.value.estado && historico.value.clienteEstadoAnterior) ||
      (historico.value.cidade && historico.value.clienteCidadeAnterior) ||
      (historico.value.bairro && historico.value.clienteBairroAnterior) ||
      (historico.value.rua && historico.value.clienteRuaAnterior) ||
      (historico.value.numero && historico.value.clienteNumeroAnterior) ||
      (historico.value.complemento && historico.value.clienteComplementoAnterior),
  )
  const paresDeValoresSecaoCliente = computed(() => [
    {
      contentTitle: 'Nome',
      currentValue: historico.value.clienteNome,
      previousValue: historico.value.clienteNomeAnterior,
    },
    {
      contentTitle: 'Email',
      currentValue: historico.value.clienteEmail,
      previousValue: historico.value.clienteEmailAnterior,
    },
    {
      contentTitle: 'CPF',
      currentValue: historico.value.clienteCpf,
      previousValue: historico.value.clienteCpfAnterior,
    },
    { contentTitle: 'RG', currentValue: historico.value.clienteRg, previousValue: historico.value.clienteRgAnterior },
    {
      contentTitle: 'Órgão Emissor',
      currentValue: historico.value.clienteOrgaoEmissor,
      previousValue: historico.value.clienteOrgaoEmissorAnterior,
    },
    {
      contentTitle: 'Data de Nascimento',
      currentValue: historico.value.clienteDataNascimento,
      previousValue: historico.value.clienteDataNascimentoAnterior,
    },
    { contentTitle: 'CEP', currentValue: historico.value.cep, previousValue: historico.value.clienteCepAnterior },
    {
      contentTitle: 'Estado',
      currentValue: historico.value.estado,
      previousValue: historico.value.clienteEstadoAnterior,
    },
    {
      contentTitle: 'Cidade',
      currentValue: historico.value.cidade,
      previousValue: historico.value.clienteCidadeAnterior,
    },
    {
      contentTitle: 'Bairro',
      currentValue: historico.value.bairro,
      previousValue: historico.value.clienteBairroAnterior,
    },
    { contentTitle: 'Rua', currentValue: historico.value.rua, previousValue: historico.value.clienteRuaAnterior },
    {
      contentTitle: 'Número',
      currentValue: historico.value.numero,
      previousValue: historico.value.clienteNumeroAnterior,
    },
    {
      contentTitle: 'Complemento',
      currentValue: historico.value.complemento,
      previousValue: historico.value.clienteComplementoAnterior,
    },
  ])
  return { secaoClienteFoiAlterada, paresDeValoresSecaoCliente }
}
